module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_47.dfcb28da.png";